import { render, staticRenderFns } from "./techprocessesAddWasteView.vue?vue&type=template&id=27725570&scoped=true&"
import script from "./techprocessesAddWasteView.vue?vue&type=script&lang=js&"
export * from "./techprocessesAddWasteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27725570",
  null
  
)

export default component.exports